import { Injectable } from "@angular/core";
import { Http, RequestOptions, Headers, Response } from "@angular/http";
import { DormantFeedback } from "app/_models/dormantFeedback";
import { Observable } from "rxjs";
import { AuthenticationService } from "./authentication.service";
import { EnvironmentService } from "./environment.service";

@Injectable()
export class DormantFeedbackService {
    private baseUrl: string = this.environmentService.getBaseURL() + '/api';

    constructor(
        private http: Http,
        private authenticationService: AuthenticationService,
        private environmentService: EnvironmentService) {
    }

    all(): Observable<DormantFeedback[]> {
        return this.http
            .get(`${this.baseUrl}/dormantfeedbacks?populate=customer`, this.makeHeaders())
            .map(mapDormantFeedbacks);
    }

    getAllForDealer(dealerId: string): Observable<DormantFeedback[]> {
        return this.http
            .get(`${this.baseUrl}/dormantfeedbacks?dealer=${dealerId}&populate=customer`, this.makeHeaders())
            .map(mapDormantFeedbacks);
    }

    findById(id: string): Observable<DormantFeedback> {
        let dormantFeedbackResult = this.http
            .get(`${this.baseUrl}/dormantfeedbacks/${id}`, this.makeHeaders())
            .map(mapDormantFeedback);
        return dormantFeedbackResult;
    }

    findByCustomerId(customerId: string): Observable<DormantFeedback> {
        let dormantFeedbackResult = this.http
            .get(`${this.baseUrl}/dormantfeedbacks/customer/${customerId}`, this.makeHeaders())
            .map(mapDormantFeedback);
        return dormantFeedbackResult;
    }

    create(dormantFeedback: DormantFeedback): Observable<DormantFeedback> {
        let dormantFeedbackResult = this.http
            .post(`${this.baseUrl}/dormantfeedbacks`, JSON.stringify(dormantFeedback), this.makeHeaders())
            .map(mapDormantFeedback);
        return dormantFeedbackResult;
    }

    update(dormantFeedback: DormantFeedback): Observable<Response> {
        return this.http
            .put(`${this.baseUrl}/dormantfeedbacks/${dormantFeedback._id}`, JSON.stringify(dormantFeedback), this.makeHeaders());
    }

    private makeHeaders(): RequestOptions {
        let headers = new Headers();

        headers.append('Authorization', this.authenticationService.getToken());
        headers.append('Content-Type', 'application/json');
        headers.append('charset', 'UTF-8 ');
        headers.append('Accept', 'application/json');

        let options = new RequestOptions({ headers: headers });
        return options;
    }
}

function mapDormantFeedback(response: Response): DormantFeedback {
    return toDormantFeedback(response.json());
}

function mapDormantFeedbacks(response: Response): DormantFeedback[] {
    return response.json().map(toDormantFeedback);
}

function toDormantFeedback(r: any): DormantFeedback {
    let dormantFeedback = <DormantFeedback>({
        _id: r._id,
        customer: r.customer,
        dealer: r.dealer,
        mauticId: r.mauticId,
        carSold: r.carSold,
        forgotBooking: r.forgotBooking,
        carWorkshop: r.carWorkshop,
        customerService: r.customerService,
        moved: r.moved,
        price: r.price,
        message: r.message,
        handled: r.handled,
        note: r.note,
        createdAt: r.createdAt,
        updatedAt: r.updatedAt
    });
    return dormantFeedback;
}


// WEBPACK FOOTER //
// ./src/app/_services/dormantFeedback.service.ts